import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
